module finadai.app.granters.create {
  export var NAME = 'finadai.app.granters.create'
  function grantersCreateController($scope, grantersService: services.GrantersService, notify, $state, data){
    $scope.agentData = data;
    $scope.isCreate = $state.is('app.granters.create')
    $scope.submit = (form: ng.IFormController) => {
      if(form.$valid){
        grantersService.save($scope.agentData).then(response => {
          notify('Registro guardado');
          $state.go('app.granters.list');
        });
      }
    }
  }
  export function run(){
    var create = angular.module(NAME, []);
    create.controller('grantersCreateController', grantersCreateController);
  }
}
finadai.app.granters.create.run();